import delay from 'lodash/delay';
import { useEffect, useRef } from 'react';

import useClientOptionsByTeams from '~/store/client/hooks/useClientOptionsByTeams';
import { useStoreState } from '~/store/hooks';
import { IClientOptionByTeam } from '~/store/client/types';
import { ClientWithAllocation } from '../model/types';

const useGetClientsGU = (clientsAllocationsFields: ClientWithAllocation[]) => {
  const { loading, loadMore, setClientOptionsTeamIds, setCurrentClientOption, items } =
    useClientOptionsByTeams();

  const { availableActTeams } = useStoreState(state => state.actTeam);

  useEffect(() => {
    setClientOptionsTeamIds(availableActTeams.map(team => team.id));
  }, [setClientOptionsTeamIds, availableActTeams]);

  // Set into Select components selected clients on first render
  useEffect(() => {
    delay(() => {
      setCurrentClientOption(
        clientsAllocationsFields.map(
          item =>
            ({
              id: item.clientId,
              name: item.name,
              photo: item.photo,
              team: item.team,
              firstName: '',
              lastName: '',
            } as IClientOptionByTeam),
        ),
      );
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadMoreRef = useRef(loadMore);
  loadMoreRef.current = loadMore;

  const itemsRef = useRef(items);
  itemsRef.current = items;

  const fieldsRef = useRef(clientsAllocationsFields);
  fieldsRef.current = clientsAllocationsFields;

  const setCurrentClientOptionRef = useRef(setCurrentClientOption);
  setCurrentClientOptionRef.current = setCurrentClientOption;

  useEffect(() => {
    if (loading) return;

    const fields = fieldsRef.current;
    if (!fields.length) return;

    const loadedIds = new Set(itemsRef.current.map(c => c.id));
    const missingFields = fields.filter(f => !loadedIds.has(f.clientId));

    if (!missingFields.length) return;

    if (loadMoreRef.current) {
      loadMoreRef.current();
    } else {
      setCurrentClientOptionRef.current(
        missingFields.map(
          item =>
            ({
              id: item.clientId,
              name: item.name,
              photo: item.photo,
              team: item.team,
              firstName: '',
              lastName: '',
            } as IClientOptionByTeam),
        ),
      );
    }
  }, [loading]);

  return { items, loading, loadMore, setClientOptionsTeamIds, setCurrentClientOption };
};

export default useGetClientsGU;
